namespace Portico.Directives {

    export interface ITcFormMessageController {
        tcForm: ITcFormController;
    }

    export class TcFormMessageController implements ITcFormMessageController {
        tcForm: ITcFormController;
    }

    angular.module('app').directive('tcFormMessage', [() => {
		return {
			bindToController: {},
			controller: <any>TcFormMessageController,
			controllerAs: '$message',
			link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
				const tcFormMessage: ITcFormMessageController = $ctrl[0];
				const tcForm: ITcFormController = $ctrl[1];

				tcFormMessage.tcForm = tcForm;
			},
			restrict: 'E',
			require: ['tcFormMessage', '?^tcForm'],
			scope: true,
			template:
				`<ul class="has-error" ng-if="$message.tcForm.ngForm.$invalid && ($message.tcForm.ngForm.$submitted || $message.tcForm.ngForm.$dirty)">
					<li ng-if="$message.tcForm.ngForm[tcInput.key].$invalid && ($message.tcForm.ngForm.$submitted || $message.tcForm.ngForm[tcInput.key].$touched) && $message.tcForm.ngForm[tcInput.key].$error.maxlength" ng-repeat-start="tcInput in $message.tcForm.tcInputs">
						{{tcInput.maxlengthMessage}}
					</li>
					<li ng-if="$message.tcForm.ngForm[tcInput.key].$invalid && ($message.tcForm.ngForm.$submitted || $message.tcForm.ngForm[tcInput.key].$dirty) && $message.tcForm.ngForm[tcInput.key].$error.minlength">
						{{tcInput.minlengthMessage}}
					</li>
					<li ng-if="$message.tcForm.ngForm[tcInput.key].$invalid && ($message.tcForm.ngForm.$submitted || $message.tcForm.ngForm[tcInput.key].$dirty) && $message.tcForm.ngForm[tcInput.key].$error.pattern">
						{{tcInput.patternMessage}}
					</li>
					<li ng-if="$message.tcForm.ngForm[tcInput.key].$invalid && ($message.tcForm.ngForm.$submitted || $message.tcForm.ngForm[tcInput.key].$dirty) && $message.tcForm.ngForm[tcInput.key].$error.required" ng-repeat-end>
						{{tcInput.requiredMessage}}
					</li>
				</ul>`
		};
    }]);
}